/**
 * debug-log — opt-in console logging for noisy diagnostic modules.
 * (86ca7n8d4, Sabeeh 2026-06-11)
 *
 * The client console was flooded on every page load (dozens of
 * conversion-funnel debug lines, campaign-loader timers, etc.), which
 * obscured real warnings/errors and added noise while debugging live.
 * Per Sabeeh: do NOT strip logs globally — keep them available for live
 * debugging. So the noisy modules route through this gate instead:
 *
 *   - dev builds (`npm run dev`): logs always on
 *   - production: silent by default; flip on per-browser with
 *       localStorage.setItem('ob_debug', '1')   (refresh after)
 *     and back off with localStorage.removeItem('ob_debug').
 *
 * console.warn / console.error are NOT routed through this — real
 * problems always surface.
 */

export function debugLogsEnabled(): boolean {
  try {
    if (import.meta.env.DEV) return true;
    return localStorage.getItem('ob_debug') === '1';
  } catch {
    return false;
  }
}

/** Drop-in replacement for console.log in noisy diagnostic modules. */
export function dlog(...args: unknown[]): void {
  if (debugLogsEnabled()) console.log(...args);
}

/** Gated console.time / console.timeEnd for perf-timer diagnostics. */
export function dtime(label: string): void {
  if (debugLogsEnabled()) console.time(label);
}
export function dtimeEnd(label: string): void {
  if (debugLogsEnabled()) console.timeEnd(label);
}
